/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how columns animate while moving.
 */
export var ColumnMovingAnimationMode = /*@__PURE__*/ (function (ColumnMovingAnimationMode) {
    /**
     * Automatically decides on the animation mode to use.
     */
    ColumnMovingAnimationMode[ColumnMovingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    ColumnMovingAnimationMode[ColumnMovingAnimationMode["None"] = 1] = "None";
    /**
     * The cells slide on top of the others to its desired position.
     */
    ColumnMovingAnimationMode[ColumnMovingAnimationMode["SlideOver"] = 2] = "SlideOver";
    return ColumnMovingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnMovingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnMovingAnimationMode', 'Auto,0|None,1|SlideOver,2');
//# sourceMappingURL=ColumnMovingAnimationMode.js.map
